import Util from '@/utils/util'
import Axs from '@/utils/axs'
import {defineStore} from 'pinia'
import storeInfoFun from '@/info.js'
import { ElMessage } from "element-plus";

let storeFunc = defineStore("zhsq3/propertyCompany",{
    state:()=>{
        return {
           //业务数据  count:99

    
        }
    },
    actions:{

        getTempDataForSelect(callback,failback, forceload)
        {
         
            //debugger;
             if(!forceload &&  !Util.isEmpty(this.tempDataForSelect))
             {
                 if(callback)
                 {
                     callback(this.tempDataForSelect)
                 }
                 return;
             }

          
             let storeInfo = storeInfoFun();
             let url = storeInfo.linkUrl + "api/zhsq/propertyCompany/loadAll";
           
             Axs.get(url, {}, null, (req) => {
                
                 let data = req.data;
                 this.tempDataForSelect = []
                 data.forEach(element => {
                     let selectObj = {
                         id:element.id,
                         label:element.name,
                         value:element,
                         disabled:false
                     }
                     this.tempDataForSelect.push(selectObj);
                 });
                 if(callback)
                 {
                     callback(this.tempDataForSelect)
                 }
             }, (err) => {
                
                 if(failback)
                 failback(err)
             },undefined,true)
        },
        clearTempDataForSelect()
        {
             this.tempDataForSelect = null;
        },
 
         getTempDataByID(id) {
            //  if (Util.isEmpty(this.tempDataForSelect))
            //  {
            //      this.getTempDataForSelect()
            //  }
             if (Util.isEmpty(this.tempDataForSelect))
             {
                 return null;
             }
             let find = null
             this.tempDataForSelect.forEach(element => {
                if (Number(element.id) == Number(id))
                     find = element;
             });
             return find;
         },

     
         async unBindUser(id,callback,failback)
            {
                let storeInfo = storeInfoFun();
                let url = storeInfo.linkUrl + "api/zhsq/propertyCompany/unBindUser";
                let req = await Axs.postAsync(url, {id},{})
                if(Util.isEmpty(req))
                    return;
                if(req.status != 200)
                {
                    ElMessage({type: "error",message:req.message});
                    return;
                }
                ElMessage({type: "info",message:"解绑成功!"});
                if(!Util.isEmpty(callback))
                {
                    callback(req);
                }
            },


            async loadDataByIDAsync(id) {
                // console.log("loadDataByIDAsync==>??????????????id=",id);
                 if(Util.isEmpty(id))
                 {
                    return null
                 }
                 let storeInfo = storeInfoFun();
                 let url = storeInfo.linkUrl + "api/zhsq/propertyCompany/load";
                 let ret =  await Axs.getAsync(url, {id})
                 let data = ret.data;
                 if(Util.isEmpty(data))
                 {
                     return new Promise((resolve,reject)=> {
                         resolve(null);
                     });
                 }
                 return new Promise((resolve,reject)=> {
                     let retData = null
                     if(data.length > 0)
                         retData = data[0]
                     resolve(retData);
                 });
     
              }
        //方法
        // doSum()
        // {
        //     this.count++
        // }
    },
    getters:{
        //计算属性，只读属性
    },
    persist: false
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc